import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <h4>{`Find me on other platforms:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://leehongyan-cv.netlify.app/"
      }}>{`CV Website`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/leehongyan"
      }}>{`LinkedIn`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Hongyanlee0614"
      }}>{`GitHub`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.instagram.com/yanyanisluv/"
      }}>{`Instagram`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://medium.com/@hongyanlee0614"
      }}>{`Medium`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      